module.exports = __webpack_public_path__ + "static/WEDDING E&M-433-79335d9dc6c7b9c110638e66cab634bf.jpg";